export const POLICY_LIBRARY = {
  navLink: 'admin-nav-policies',
  titleInput: 'policy-generate-title-input',
  clauseCheckbox: 'policy-generate-clause-checkbox',
  generateButton: 'policy-generate-submit-button',
  policyCard: 'policy-library-card',
  distributeButton: 'policy-distribute-button',
  distributeAllCheckbox: 'policy-distribute-all-checkbox',
  distributeEmployeeCheckbox: 'policy-distribute-employee-checkbox',
  distributeConfirmButton: 'policy-distribute-confirm-button',
  legalDisclaimer: 'legal-disclaimer-text',
};

export const EMPLOYEE_RECEIPTS = {
  blockedBanner: 'receipts-blocked-banner',
  receiptRow: 'receipt-row',
  previewButton: 'receipt-preview-button',
};

export const RECEIPTS_TAB = {
  uploadButton: 'receipts-tab-upload-button',
  periodInput: 'receipts-tab-period-input',
  issueDateInput: 'receipts-tab-issue-date-input',
  noteInput: 'receipts-tab-note-input',
  fileInput: 'receipts-tab-file-input',
  submitButton: 'receipts-tab-submit-button',
  historyRow: 'receipts-tab-history-row',
  previewButton: 'receipts-tab-preview-button',
  invalidateButton: 'receipts-tab-invalidate-button',
  invalidateReasonInput: 'receipts-tab-invalidate-reason-input',
  invalidateConfirmButton: 'receipts-tab-invalidate-confirm-button',
  invalidatedBadge: 'receipts-tab-invalidated-badge',
};

export const RECEIPT_PREVIEW = {
  dialog: 'receipt-preview-dialog',
  downloadButton: 'receipt-preview-download-button',
  closeButton: 'receipt-preview-close-button',
};

export const RECEIPTS_BATCH = {
  navLink: 'admin-nav-recibos',
  periodInput: 'receipts-batch-period-input',
  issueDateInput: 'receipts-batch-issue-date-input',
  employeeRow: 'receipts-batch-employee-row',
  uploadAllButton: 'receipts-batch-upload-all-button',
  progressBanner: 'receipts-batch-progress-banner',
  resultBanner: 'receipts-batch-result-banner',
};

export const EMPLOYEE_VACATION_REQUEST = {
  blockedBanner: 'vacation-request-blocked-banner',
  requestButton: 'vacation-request-open-button',
  startDateInput: 'vacation-request-start-date-input',
  endDateInput: 'vacation-request-end-date-input',
  daysInput: 'vacation-request-days-input',
  submitButton: 'vacation-request-submit-button',
  requestRow: 'vacation-request-row',
  homeAwaitingBanner: 'home-vacation-awaiting-confirmation-banner',
  homeConfirmButton: 'home-vacation-confirm-button',
  homeDeclineButton: 'home-vacation-decline-button',
};

export const ANNOUNCEMENTS = {
  adminNavLink: 'admin-nav-announcements',
  messageInput: 'announcement-message-input',
  recipientAllRadio: 'announcement-recipient-all-radio',
  recipientSpecificRadio: 'announcement-recipient-specific-radio',
  recipientEmployeeCheckbox: 'announcement-recipient-employee-checkbox',
  submitButton: 'announcement-submit-button',
  adminRow: 'announcement-admin-row',
  postIt: 'employee-announcement-postit',
  markReadButton: 'employee-announcement-mark-read-button',
  pinnedCard: 'employee-announcement-pinned-card',
  pinnedMarkReadButton: 'employee-announcement-pinned-mark-read-button',
};
